import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "..";
import { PublicLc } from "../../dtos/lc";
import LcApi from "../../api/lc";

class LcServiceReader extends ServiceReader {
  public async all(): Promise<PublicLc[]> {
    return await new LcApi().get();
  }
}
class LcServiceCreator extends ServiceCreator {}
class LcServiceUpdater extends ServiceUpdater {}
class LcServiceDeleter extends ServiceDeleter {}

export default class LcService extends Service {
  public get read(): LcServiceReader {
    return new LcServiceReader();
  }
  public get create(): LcServiceCreator {
    return new LcServiceCreator();
  }
  public get update(): LcServiceUpdater {
    return new LcServiceUpdater();
  }
  public get delete(): LcServiceDeleter {
    return new LcServiceDeleter();
  }
}
